<div *ngIf="isAdmin" class="content-wrapper-inner">
  <div *ngIf="isAnySpinnerActive()" class="full-page-spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div *ngFor="let groupKey of sortedGroupKeys" class="settings-container">
    <h3 class="mb-20">{{ groupKey }}</h3>
    <div class="row">
      <div *ngFor="let model of groupedModels[groupKey]" class="col-6">
        <div class="d-flex justify-content-start align-items-start gap-20 py-10">
          <div class="w-50">
            <label class="form-label">{{ getTitle(model.model.name) }}</label>
          </div>
          <div class="w-100">
            <setting-value-component [type]="model.model.valType" [val]="model.val" (settingChange)="onSettingChange($event, model)"></setting-value-component>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
